import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Header, Label, Button, Input, Dropdown } from 'semantic-ui-react';

import { Field, reduxForm, getFormValues } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';
import * as formValidators from '../../scripts/formValidators';
import { connect } from 'react-redux';
import {
  MotifButton,
  MotifFormField,
  MotifInput,
  MotifLabel,
  MotifSelect,
  MotifOption,
  MotifModal,
  MotifIcon,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from '@ey-xd/motif-react';
import { addAttribute } from '../../common/Attribute';

const DenyClientReopenRequestModal = ({
  showDenyClientReopenRequestModal,
  handleSubmit,
  handleDenyClientReopenRequest,
  toggleShowDenyClientReopenRequestModal,
  gridCurrentState,
}) => {
  const HeaderWrapper = ({ children }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
      }}
    >
      {children}
    </div>
  );

  const closeButtonProps = {
    title: 'Close Deny Client Reopen Request modal',
    ariaLabel: 'Close Deny Client Reopen Request modal',
    dataTestid: 'close',
  };

  useEffect(() => {
    //Add Attribute(type=button) to all button elements having attribute(role = 'combobox')
    addAttribute("button[role = 'combobox']", 'type', 'button');
  });

  return (
    <MotifModal
      variant="alt"
      show={showDenyClientReopenRequestModal}
      onClose={() => toggleShowDenyClientReopenRequestModal()}
      size="xl"
      data-testid="DenyClientReopenRequests"
    >
      <MotifModalHeader closeButtonProps={closeButtonProps}>
        <HeaderWrapper>
          <span className="ml-2">Deny Client Reopen Request(s)</span>
        </HeaderWrapper>
      </MotifModalHeader>

      <MotifModalBody>
        <form onSubmit={handleSubmit} className="auth">
          <span className="checklistActionMsg">
            You selected{' '}
            {gridCurrentState &&
              new Set(
                gridCurrentState
                  .filter((record) => record.checklistSelection)
                  .map(
                    (record) => record.checklistID + '_' + record.checklistType
                  )
              ).size}{' '}
            checklist(s).
          </span>
          <br />
        </form>
      </MotifModalBody>

      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          type="button"
          onClick={() => toggleShowDenyClientReopenRequestModal()}
          className="right"
          data-testid="Cancel"
        >
          Cancel
        </MotifButton>
        <MotifButton
          type="button"
          onClick={() => handleDenyClientReopenRequest()}
          className="right"
          data-testid="Submit"
        >
          Submit
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DenyClientReopenRequestModal.propTypes = {
  showDenyClientReopenRequestModal: PropTypes.bool,
  handleSubmit: PropTypes.func,
  toggleShowDenyClientReopenRequestModal: PropTypes.func,
  initialValues: PropTypes.object,
};

export default reduxForm({
  form: 'DenyClientReopenRequest',
  enableReinitialize: true,
})(DenyClientReopenRequestModal);
